var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"page_title"},[_vm._v("运营报表")]),_c('forms',{attrs:{"reportStatus":_vm.reportStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }